<script setup lang="ts">
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { FeatureContactPageForm } from '~/components/feature/contact-page/form'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetCustomerCare } from '~/components/widget/customer-care'
import { WidgetTelegram } from '~/components/widget/telegram'
import { WidgetInstagram } from '~/components/widget/instagram'
import { WidgetStaticPage } from '~/components/widget/static-page'

const { t } = useI18n()
const breadcrumbs = computed(() => [{ title: t('common.cooperation'), url: '/cooperation' }])
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside>
            <WidgetCustomerCare />
            <WidgetTelegram />
            <WidgetInstagram />
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
          </aside>
        </template>
        <div class="lg:col-span-3" role="main">
          <WidgetStaticPage heading-level="h1">
            <FeatureContactPageForm heading-tag="h3" :heading-text="t('common.have_questions')" />
          </WidgetStaticPage>
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
